<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-row>
      <el-form-item>
        <el-input
          size="small"
          v-model="filters.name"
          placeholder="姓名"
        ></el-input>
      </el-form-item>
      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
    };
  },
  created() {
  },
  methods: {
    initData() {
      let params = { ...this.filters };
      params.page = 1;
      this.$emit("search", params);
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {});
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  text-align: right;
  margin-bottom: 20px;
}
</style>
